import React, { ReactElement, useState } from "react";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { offlineStrings } from "./offlineStrings";
import useIsOffline from "../../../hooks/useIsOffline";
import { connectionStatus } from "../../../utils/connectionStatus";

const strings = offlineStrings;

/**
 * Offline design A: a strip at the top of the dashboard page. The page stays
 * open, so typed changes are not lost, and the shared Save buttons turn off
 * until the connection is back.
 */
const OfflineBanner = (): ReactElement | null => {
  const isOffline = useIsOffline();
  const [isChecking, setIsChecking] = useState(false);

  if (!isOffline) {
    return null;
  }

  const handleTryAgain = async () => {
    setIsChecking(true);
    try {
      await connectionStatus.checkConnection();
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="z-[18] bg-white px-4 pb-2 pt-2 md:sticky md:top-0 md:px-10 md:pt-4">
      <div
        role="status"
        className="flex flex-wrap items-center gap-x-[14px] gap-y-3 rounded-lg border border-[#E1A731] bg-[#FBF0DC] px-4 py-3 text-black"
      >
        <WifiOffIcon aria-hidden="true" sx={{ fontSize: 22, color: "#0A0A0A" }} />
        <p className="m-0 min-w-[200px] flex-1 text-[14px] leading-[1.45]">
          <strong className="font-semibold">{strings.bannerTitle}</strong>{" "}
          {strings.bannerText}
        </p>
        <button
          type="button"
          onClick={handleTryAgain}
          disabled={isChecking}
          className="rounded-lg border border-[#9E9E9E] bg-white px-4 py-[9px] text-[14px] font-semibold leading-5 text-[#0A0A0A] hover:bg-[#F7F7F8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cpaGold disabled:cursor-wait disabled:opacity-60"
        >
          {strings.tryAgainButtonText}
        </button>
      </div>
    </div>
  );
};

export default OfflineBanner;
